import React from 'react';
import '../styles/About.css';
import about from '../assest/about.jpg'

import technology from '../assest/technology.jpg'
import brainimg from '../assest/brain.jpg'


const About = () => {
  return (
    <>
      <div className='about-wrapper' id="about">
        <div className='about-container'>
          <div className='about-left'>
            <h1 className='Abouth1'>About CauZen</h1>
            {/* <h3>We Build. We Automate. We Elevate</h3> */}
            <p className='about-para'>CauZen is built on a simple belief—technology should serve people, not confuse them. We work with business owners who are strong in their domain but want to catch up with the digital world. We bring purpose to every solution and clarity to every step—because that’s how lasting innovation is built.
            </p>
            <button
              className="about-btn"
              onClick={() => {
                document.getElementById("solution").scrollIntoView({ behavior: "smooth" });
              }}
            >
              View Solution <span className="arrow"><i className="fas fa-arrow-right"></i></span>
            </button>

          </div>
          <div className='about-right'>
            <div className='about-image-box'>
              <img src={about} />
            </div>
          </div>
        </div>
      </div>
   
<div className='about-mission'>
  <div className='about-mission-container'>
    <div className='about-mission-left'>
      <div className='about-mission-box'>
              <img src={brainimg} />
            </div>
    </div>
      <div className='about-mission-right'>
        <h1> Our Mission</h1>
    
            <p>At CauZen, we collaborate with businesses and professionals dedicated to making a significant impact. Our mission is to 10X their growth through digital transformation. We accelerate their success by equipping them with the tools to grow and empowering them to expand globally with purposeful technology and innovation, all crafted with clarity.

            </p>
             <button
              className="mission-btn"
              onClick={() => {
                document.getElementById("Careers").scrollIntoView({ behavior: "smooth" });
              }}
            >
              Join Cauzen <span className="arrow"><i className="fas fa-arrow-right"></i></span>
            </button>

      </div>
  </div>
</div>

<div className='vision-wrapper'>
  <div className='vision-container'>
    <div className='vision-left'>
      <h1>Our Vision</h1>
      <p>Accelerating Digital Transformation for Businesses and Professionals. By Partnering and Equipping Our Customers with Purposeful Technology, crafted with Clarity and Scalable for Real World Impact.</p>
    <button
              className="vision-btn"
              onClick={() => {
                document.getElementById("solution").scrollIntoView({ behavior: "smooth" });
              }}
            >
             Explore more &nbsp;<span className="arrow"><i className="fas fa-arrow-right"></i></span>
            </button>
    </div>


    <div className='vision-right'>
      <div className='vision-box'>
      <img src={technology} alt="vision-image"/>
      </div>
    </div>
  </div>
</div>



































































    </>
  );
};

export default About;
